export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-300" id="footer">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </div>
              <span className="text-xl font-heading text-foreground-100 whitespace-nowrap">
                蘑菇影视
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              蘑菇影视致力于为广大观众提供高清、超清、4K、蓝光画质的影视资源，免费在线观看，无广告干扰，播放流畅不缓冲，打造极致的在线观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 whitespace-nowrap">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '影视专题', href: '#index' },
                { label: '热门话题', href: '#topics' },
                { label: '精选推荐', href: '#cards' },
                { label: '热播榜单', href: '#ranking' },
                { label: '联系我们', href: '#contact' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 whitespace-nowrap">影视类型</h4>
            <ul className="space-y-2.5">
              {['动作大片', '科幻巨制', '喜剧剧场', '悬疑烧脑', '动漫世界', '纪录片'].map((item) => (
                <li key={item}>
                  <span className="text-sm text-foreground-400 cursor-pointer">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 whitespace-nowrap">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              平台正在积极拓展合作渠道，更多优质内容合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {year} 蘑菇影视 - 高清超清免费在线观看。本站所有资源均来自互联网，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-5">
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-300 transition-colors">隐私政策</span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-300 transition-colors">用户协议</span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-300 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}